import { CREDITS_PAGE_PERMISSIONS } from '../pages/credits/credits-tabs.ts';
import { ORG_DETAIL_PERMISSION, ORG_LIST_PERMISSION } from '../pages/organizations/org-access.ts';
import { ROLE_LIST_PERMISSION } from '../pages/roles/role-access.ts';
import { USER_DETAIL_PERMISSION, USER_LIST_PERMISSION } from '../pages/users/user-access.ts';

export type MenuPermission = string | readonly string[];

export const ADMIN_ROUTE_PERMISSIONS = {
  dashboard: 'dashboard:list',
  dashboardTrends: 'dashboard:trends:list',
  dashboardAnalytics: 'dashboard:analytics:list',
  dashboardModelUsage: 'dashboard:model_usage:list',
  users: USER_LIST_PERMISSION,
  userDetail: USER_DETAIL_PERMISSION,
  organizations: ORG_LIST_PERMISSION,
  organizationDetail: ORG_DETAIL_PERMISSION,
  credits: CREDITS_PAGE_PERMISSIONS,
  creditPricing: 'credits:pricing:list',
  rechargeOrders: 'credits:orders:list',
  creditPackages: 'credits:packages:list',
  admins: 'admins:list',
  roles: ROLE_LIST_PERMISSION,
  permissions: 'permissions:list',
  systemConfig: 'system:config:list',
  aiUsage: 'ai_usage:list',
  aiConfig: 'ai_config:list',
  projectExports: 'project_exports:list',
} as const;

export function isMenuItemVisible(permission: MenuPermission, granted: readonly string[]): boolean {
  const required = typeof permission === 'string' ? [permission] : permission;
  return required.some((code) => granted.includes(code));
}
